var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"postimedown"},[(
    _vm.status == 'shan'
    )?_c('span',{staticClass:"blink",staticStyle:{"font-weight":"700"}},[_vm._v(" Countdown : You have timed out ")]):_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v(" Countdown: "+_vm._s(_vm.localtimer.minutes)+" minutes "+_vm._s(_vm.localtimer.seconds)+" seconds ")])])}
var staticRenderFns = []

export { render, staticRenderFns }